<template>
  <DefaultLayout>
    <div v-if="loading">
      <v-icon name="ri-loader-2-fill" animation="spin" class="icon" />
    </div>
    <div v-else>
      <div class="container">
        <h1 class="title">Preguntas frecuentes</h1>
        <br>
        <p class="info">Pulsa sobre las distintas preguntas para ver su respuesta.</p>
        <div class="accordion">
          <div v-for="(item, index) in faqs" :key="index" class="accordion-item">
            <button @click="toggle(item.id)" class="accordion-header">
              <span>{{ item.question }}</span>
              <v-icon :name="item.open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'" class="icon" />
            </button>
            <div v-if="item.open" class="accordion-body">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { ref, onMounted } from 'vue'
import FaqsService from '@/services/FaqsService'
import FaqI from '@/interfaces/FaqInterface' 

const loading = ref(false)
const service = new FaqsService()
const faqs = ref<FaqI[]>([])

const toggle = (id: number) => {
  faqs.value = faqs.value.map(faq =>
    faq.id === id ? { ...faq, open: !faq.open } : faq
  )
}

onMounted(async () => {
  loading.value = true
  const fetchedFaqs = await service.GetFaqs()
  faqs.value = fetchedFaqs.map((faq:any) => ({ ...faq, open: false }))
  loading.value = false
})
</script>

  
  <style lang="scss" scoped>
  .container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  
  .title {
    color: $secondary-color;
  }
  span{
    color:white;
    font-size: 18px;
  }
  .info {
    color: $secondary-color;
    margin-bottom: 20px;
  }
  
  .accordion {
    width: 100%;
    max-width: 600px;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #fff;
  }
  
  .accordion-item {
    border-bottom: 2px solid #fff;
  }
  
  .accordion-header {
    width: 100%;
    padding: 16px;
    background-color: $third-color;
    border: none;
    outline: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .accordion-header:hover {
    background-color: $third-color;
  }
  
  .accordion-body {
    padding: 16px;
  }
  
  .icon {
    font-size: 24px;
  }
  </style>
  